module.exports = __webpack_public_path__ + "img/Mobilier-accueil.a54f1c4b.jpg";